<template>
    <div class="relative">
        <div class="d-flex flex-column">
            <div class="content">
                <div class="week-content">
                    <div v-for="w in weekDays" :key="w + 'wd'" class="noselect">
                        <div class="item p-3 pointer">
                            <h6 class="mb-0 text-center">
                                <strong>{{ getWeekDayText(w) }}</strong>
                            </h6>
                        </div>
                    </div>
                </div>
                <Divider />
                <div class="date-content">
                    <div
                        v-for="o of getMonthDaysOffset(month, year)"
                        :key="o + 'o'"
                        class="noselect"
                    >
                        <div class="item p-3">
                            <h6 class="mb-0 text-center inactive">{{ o }}</h6>
                        </div>
                    </div>
                    <div
                        v-for="d in daysInMonth(month, year)"
                        :key="d + 'd'"
                        :class="{
                            'cal-date-today': isToday(year, month, d),
                            clickable: countEventsDate(year, month, d) >= 1,
                        }"
                        class="noselect cal-date-wrapper"
                        @click="
                            countEventsDate(year, month, d)
                                ? dateClickCallback(year, month, d)
                                : null
                        "
                    >
                        <div class="item p-3">
                            <h6 class="mb-0 text-center">{{ d }}</h6>
                            <div class="cal-indicator-dots">
                                {{ getCntEventsDate(year, month, d) }}
                            </div>
                        </div>
                    </div>
                    <div v-for="f in getFillDates(month, year)" :key="f + 'f'" class="noselect">
                        <div class="item p-3">
                            <h6 class="mb-0 text-center inactive">{{ f }}</h6>
                        </div>
                    </div>
                </div>
            </div>
            <Divider />
            <div class="cal-footer d-flex px-3">
                <div class="arrows pointer d-flex align-items-center" @click="() => shiftMonth(-1)">
                    <BaseIcon name="chevron-left" size="lg" />
                </div>
                <div class="flex-grow d-flex align-items-center justify-content-center noselect">
                    <h6 class="text-center mb-0 font-weight-bold">
                        {{ getMonthText(month) }} {{ year }}
                    </h6>
                </div>
                <div
                    class="arrows pointer d-flex align-items-center flex-row-reverse"
                    @click="() => shiftMonth(1)"
                >
                    <BaseIcon name="chevron-right" size="lg" />
                </div>
            </div>
            <Divider />
            <!--<div class="flex-grow" />-->
        </div>
    </div>
</template>

<script>
const DOT_LIMIT = 3;
const today = new Date();

export default {
    name: 'Calendar',
    props: {
        dateClickCallback: Function,
    },
    data: () => ({
        weekDays: new Array(7).fill().map((_, i) => i),
        months: new Array(12).fill().map((_, i) => i), // Months by index (0 - 11)

        month: new Date().getMonth(), // Selected month
        year: new Date().getFullYear(), // Selected year
    }),
    methods: {
        getMonthText(monthIndex) {
            // Validate month index
            monthIndex =
                monthIndex >= this.months.length
                    ? this.months.length - 1
                    : monthIndex <= 0
                    ? 0
                    : monthIndex;
            const monthText = this.$t('general.months') || [];
            return monthText[monthIndex];
        },
        getWeekDayText(weekDayIndex) {
            weekDayIndex =
                weekDayIndex >= this.weekDays.length
                    ? this.weekDays.length - 1
                    : weekDayIndex <= 0
                    ? 0
                    : weekDayIndex;
            const weekDayText = this.$t('general.days') || [];
            return weekDayText[weekDayIndex];
        },
        daysInMonth(month, year) {
            return new Date(year, month + 1, 0).getDate();
        },
        getMonthDaysOffset(month, year) {
            let offset_length = new Date(year, month, 1).getDay();
            let offset = [];
            for (let i = offset_length; i > 0; i--) {
                let numInMonth = new Date(year, month, 1 - i).getDate();
                offset.push(numInMonth);
            }
            return offset;
        },
        getFillDates(month, year) {
            let maxDay = 6;
            return maxDay - new Date(year, month + 1, 0).getDay();
        },
        shiftMonth(dir) {
            if (this.month === 11 && dir === 1) {
                this.month = 0;
                this.year++;
            } else if (this.month === 0 && dir === -1) {
                this.month = 11;
                this.year--;
            } else {
                this.month += dir;
            }
        },
        countEventsDate(year, month, date) {
            // TODO: Read comp-props and count number of events for date in params
            return date % 5;
        },
        getCntEventsDate(year, month, date) {
            let cnt = this.countEventsDate(year, month, date);
            let res = '';
            for (let i = 0; i < cnt; i++) {
                if (i < DOT_LIMIT) res += '.';
                else break;
            }
            return res;
        },
        isToday(year, month, date) {
            return (
                today.getFullYear() === year &&
                today.getMonth() === month &&
                today.getDate() === date
            );
        },
    },
    mounted() {},
};
</script>

<style scoped>
.cal-footer {
    height: 44px;
}

.content {
    background-color: rgb(255, 255, 255);
}

.week-content {
    display: -ms-grid;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    /*grid-gap: 1px;*/
}

.cal-date-wrapper {
    width: 50%;
    margin: auto;
    border-radius: 50%;
}

.date-content {
    display: -ms-grid;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    /*grid-gap: 1px;*/
}

.cal-indicator-dots {
    text-align: center;
    float: left;
    font-size: 19px;
    color: var(--primary);
    margin-top: -10px;
    width: 100%;
    font-weight: bold;
}

.item-selected h6 {
    color: white !important;
}

.item h6.inactive {
    color: #d2d2d2 !important;
}

.arrows {
    min-width: 60px;
    padding: 0 4px;
}

.cal-date-today {
    background-color: var(--secondary);
}
.cal-date-today * {
    color: white !important;
}
@media only screen and (max-width: 600px) {
    /* TODO: This */
}
</style>
